export default {
    new: 'New',
    add: 'Add',
    'view-invoice': 'Show invoice',
    'bond-no': 'Bond No.',
    edit: 'Edit',
    save: 'Save',
    bond: 'bond',
    not: 'Non',
    posted: 'Posted',
    'delete-account-entry': 'Delete row',
    'are-you-sure-you-want-to-delete-the-entry': 'Do you want to delete this row?',
    'add-bond': 'Add bond',
    'bond-date': 'Bond date',
    'create': 'Create',
    'cancel': 'Cancel',
    'sum': 'Total:',
    'difference': 'Difference:',
    'currency-equivalent': 'Balance in another currency',
    'select-currency-to-show-the-currency-equivalent': 'Choose the currency to exchange',

    headers: {
        sequence: 'Serial',
        account: 'Account',
        debit: 'Debit',
        credit: 'Credit',
        note: 'Description',
        currency: 'Currency',
        'currency-debit': 'Foreign currency income',
        'currency-credit': 'Foreign currency expense',
        price: 'Price',
        'paper-document-no': 'Ref. Doc.',
        'date': 'Date',
    },

    'not-posted-bonds': 'Non-posted bonds',
    'all-bonds-are-posted': 'All bonds are posted',

    'context-menu': {
        'account-statement' : 'Account statement',
        'edit' : 'Edit',
        'delete' : 'Delete'
    },

    'make-sure-the-data-entered-is-correct': 'Verify that the entered data is correct'
}